import React from 'react';
import Search from '@zacousticrepo/grommet-v1-custom/components/Search';

const ZSearch = props => {
    const { searchValue, width, placeHolder, onChange = ()=> {}, onClickAway = ()=> {} } = props;
    const parameters = { placeHolder: placeHolder, onDOMChange: onChange, onBlur: onClickAway };
    const placeHolderText = placeHolder ? placeHolder : 'Select'
    return (
        <div className="zse search__wrapper">
            <Search placeHolder={placeHolderText}  inline={true} fill={true} size="large" id="searchBar" value={searchValue ? searchValue : ''} className='zse search-bar'  style={width ? { width: width } : {}} {...parameters} />
        </div>
    );
};

export { ZSearch as default };